import {connect} from "react-redux";
import {I18nextProvider} from "react-i18next";
import i18n from "./i18n";
                                                  

function mapStateToProps(state                  ) {
	i18n.changeLanguage(state.config.language);
	return {
		i18n: i18n
	};
}

export default connect(mapStateToProps)(I18nextProvider);
